import { render } from "./Footer.vue?vue&type=template&id=e53bbf22&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=e53bbf22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e53bbf22"

export default script